import { useConversation, useConversations } from "./use-conversations";
import type { Conversation } from "../model/types";

/** Открытая беседа: четыре состояния экрана, без «пусто» на месте ошибки (ai/frontend-standard.md §2.6). */
export type SelectedConversation =
  | { kind: "none" }
  | { kind: "loading" }
  | { kind: "error"; retry: () => void }
  | { kind: "ready"; conversation: Conversation };

/**
 * Беседа берётся из списка; отдельный запрос — только если её там нет (новая личка, архив, ссылка из уведомления).
 * Пока список грузится, детальный запрос не уходит: почти всегда беседа в нём есть, и второй запрос — дубль.
 * Архив читается только из кэша: на телефоне с открытой беседой его никто не грузит, и ждать его нельзя.
 */
export function useSelectedConversation(conversationId: string | null, enabled = true): SelectedConversation {
  const active = useConversations(false);
  const archived = useConversations(true, false);
  const fromList = conversationId
    ? (active.data?.find((c) => c.id === conversationId) ?? archived.data?.find((c) => c.id === conversationId))
    : undefined;
  const needDetail = enabled && !!conversationId && !fromList && !active.isPending;
  const detail = useConversation(needDetail ? conversationId : null);

  if (!enabled || !conversationId) return { kind: "none" };
  const conversation = fromList ?? detail.data;
  if (conversation) return { kind: "ready", conversation };
  if (detail.isError) return { kind: "error", retry: () => void detail.refetch() };
  return { kind: "loading" };
}
